<script>
import toggleModal from '@/mixins/toggleModal';
import { mapActions } from 'vuex';
import { DeleteOutlined } from '@ant-design/icons-vue';

export default {
  components: { DeleteOutlined },
  data() {
    return {
      anchorList: [],
      anchorListRemoved: [],
    };
  },
  props: {
    anchorListNode: {
      type: Array,
    },
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      addOrEditCategory: 'blogs/addOrEditCategory',
    }),
    onCancel() {
      this.hideModal();
      this.$emit('update:selectedAnchorListNode', []);
    },
    onSave() {
      if (this.anchorListRemoved && this.anchorListRemoved.length) {
        this.anchorListRemoved.map((anchor) => anchor.classList.remove('anchor'));
      }
      return this.onCancel();
    },
    onDeleteAnchor(anchor, anchorIndex) {
      this.anchorList = this.anchorList.filter((item, index) => index !== anchorIndex);
      this.anchorListRemoved = [...this.anchorListRemoved, anchor];
    },
  },
  mounted() {
    this.anchorList = this.anchorListNode;
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" @cancel="onCancel" >
    <h1>
      Remove ancho
    </h1>
    <div
      class="anchor-links"
    >
      <div
        class="anchor"
        v-for="(item , index) in anchorList"
        :key="item.innerText+index"
      >
        <h3 class="anchor-text">
          {{ item.innerText }}
        </h3>
        <a-button
          class="anchor-text"
          @click="onDeleteAnchor(item, index)"
          type="primary"
          danger
        >
          <DeleteOutlined /> Delete
        </a-button>
      </div>
    </div>
    <div
      class="buttons"
      v-if="anchorListRemoved.length"
    >
      <a-button
        type="primary"
        class="save-button"
        @click="onSave"
      >
        Save
      </a-button>
    </div>
  </a-modal>
</template>

<style lang="scss" scoped>
  .anchor-links {
    display: flex;
    flex-direction: column;
    max-height: 500px;
    overflow-y: scroll;
  }

  .anchor {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;

    border-bottom: 1px solid black;
    padding: 20px 0;

    &:last-child {
      border: none;
    }
  }

  .buttons {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
    padding: 0 30px;
  }

  .save-button {
    height: 40px;
    width: 120px;
    font-size: 20px;
  }

</style>
